import script from "./multiple-checks.vue?vue&type=script&lang=js"
export * from "./multiple-checks.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/horizontal/multiple-checks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2910fa90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2910fa90', __exports__)) {
    console.log('reload')
    api.reload('2910fa90', __exports__)
  }
  
}


export default __exports__